import { Injectable } from '@angular/core'
import { RoleConstants } from './../generated/generated'
import { CurrentUserService } from './current-user.service'

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  constructor(private currentUserService: CurrentUserService) {
    this.currentUserService.user$.subscribe((data) => {
      this.roles = data?.roles
    })
  }

  private roles: Array<string> = []

  public doesUserHavePermission(rolesToCheck: Array<string>) {
    if (!this.roles) return false

    if (rolesToCheck.includes(RoleConstants.superAdmin)) {
      //If we're specifically defining superAdmin, then let's not short-circuit by assuming 'admin' can access it too.
      if (this.roles.includes(RoleConstants.superAdmin)) {
        return true
      } else {
        return false
      }
    }

    if (this.roles.includes(RoleConstants.admin) || this.roles.includes(RoleConstants.superAdmin)) return true

    if (this.currentUserService.user$.getValue().roles.some((role) => rolesToCheck.includes(role))) {
      return true
    } else {
      return false
    }
  }
}
